module.exports = __webpack_public_path__ + "img/votaciones-menu.9b6173bc.svg";